import { gql } from '@apollo/client/core';
/* eslint-disable import/prefer-default-export */

export const CREATE_JOB_POST = gql`
  mutation CreateJob($jobInput: JobInput!) {
    createJob(jobInput: $jobInput) {
      id
    }
  }
`;
